import { z } from 'zod';

export const name = z
  .string()
  .min(1, { message: 'Введите имя' })
  .refine(
    (value) => !/[^a-zA-Zа-яА-Я0-9\s\-\']/g.test(value ?? ''),
    'Недопустимые символы',
  )
  .refine(
    (value) => !(value?.startsWith(' ') ?? false),
    'Имя не может начинаться с пробела',
  );
